/* eslint-disable @next/next/no-sync-scripts */
import Script from 'next/script'
import React from 'react'

/**
 * Snapchat Pixel Integration
 *
 * This script handles the Snapchat conversion tracking pixel.
 * The pixel only fires after the user has approved marketing tracking in OneTrust.
 *
 * Pixel ID: 81b46b3f-d77a-44a3-aaa6-3a603fc5022d
 */

const SNAPCHAT_PIXEL_ID = '81b46b3f-d77a-44a3-aaa6-3a603fc5022d'

const snapchatPixelScript = `
(function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
{a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
a.queue=[];var s='script';r=t.createElement(s);r.async=!0;
r.src=n;var u=t.getElementsByTagName(s)[0];
u.parentNode.insertBefore(r,u);})(window,document,
'https://sc-static.net/scevent.min.js');

snaptr('init', '${SNAPCHAT_PIXEL_ID}', {});
snaptr('track', 'PAGE_VIEW');
`

export function renderSnapchatPixel() {
  return (
    <Script
      id="snapchat-pixel"
      strategy="afterInteractive"
      type="text/plain"
      className="optanon-category-C0004"
      dangerouslySetInnerHTML={{
        __html: snapchatPixelScript,
      }}
    />
  )
}
